import { Component, OnInit } from '@angular/core';
import { ItemAuditoria } from '../../../shared/classes/ItemAuditoria';
import { AuditoriaService } from '../../../shared/services/auditoria.service';

@Component({
  selector: 'app-auditoria',
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.css'],
  providers: [AuditoriaService]
})
export class AuditoriaComponent implements OnInit {

  itensAuditoria: Array<ItemAuditoria>;
  itensAuditoriaOriginal: Array<ItemAuditoria>; 
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  msgAviso: string;
  class_icon_msg: string;

  constructor(private auditoriaService: AuditoriaService) { }

  ngOnInit() {
    this.itensAuditoriaOriginal = new Array<ItemAuditoria>();
    this.getAuditorias();
    
  }

  getAuditorias(){
    this.auditoriaService.getItemsAuditoria().then(auditorias => {

      this.itensAuditoria = auditorias;
      this.itensAuditoriaOriginal = auditorias.map(x => Object.assign({}, x));
     
    }).catch(error => {
      console.error(error);
      this.class_icon_msg = this.class_fa_icon_nok;
      if(error.status == 403 || error.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      document.getElementById("showMensagensModalAudit").click()
    });
  }

  updateAuditorias(){
    this.auditoriaService.updateAuditorias(this.itensAuditoria).then(result => {
      this.msgAviso = result;
      (<HTMLInputElement> document.getElementById("btnsalvar")).disabled = true;
      this.class_icon_msg = this.class_fa_icon_ok;
      document.getElementById("showMensagensModalAudit").click()
    }).catch(error => {
      this.class_icon_msg = this.class_fa_icon_nok;
      if(error.status == 403 || error.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      document.getElementById("showMensagensModalAudit").click()
    }) 
  }

  enableSalvarButton(): void{
    //console.log("itensAuditoria:", this.itensAuditoria)
    if(this.areDifferentByActiveStatus(this.itensAuditoriaOriginal, this.itensAuditoria)){
      (<HTMLInputElement> document.getElementById("btnsalvar")).disabled = false;
    }else{
      (<HTMLInputElement> document.getElementById("btnsalvar")).disabled = true;
    }   
  }

  areDifferentByActiveStatus(array1: Array<ItemAuditoria>, array2: Array<ItemAuditoria>) {
    var statusArray1 = array1.map( x => { return x.isActive; });
    //console.log("statusArray1",statusArray1)
    var statusArray2 = array2.map( x => { return x.isActive; });
    //console.log("statusArray2",statusArray2)
    return (statusArray1.join(',') !== statusArray2.join(',') );
  } 

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/administracao/auditoria/auditoria.component.ts